// Fetch demographics data from API
const fetchDemographicsData = async (geoLevel = null, areaId = null) => {
  try {
    // Check if we're in local environment
    if (process.env.REACT_APP_CURRENT_ENV === 'local') {
      // Fetch from public folder for local development
      let response;

      if (geoLevel == 'county') {
        // Fetch county data for specific state
        console.log('🔄 FETCHDEMOGRAPHICSDATA: Fetching county data for state:', areaId);
        // Temporary: Return empty for counties as we only have blockgroups for TX
        return { type: 'FeatureCollection', features: [] };
      } else if (geoLevel == 'blockgroup') {
        // Fetch block group data for specific county
        console.log('🔄 FETCHDEMOGRAPHICSDATA: Fetching block group data for county:', areaId);
        // Force TEXAS CloudFront URL for testing
        const responseUrl = `https://ddt94p7yna12s.cloudfront.net/demographics/michigan.geojson`;
        response = await fetch(responseUrl);
      } else {
        // Fetch nationwide data
        // Temporary: Return empty to stop 404/431 errors on missing files
        return { type: 'FeatureCollection', features: [] };
      }

      if (!response.ok) {
        throw new Error(`Failed to load demographics data: ${response.status}`);
      }

      const data = await response.json();
      console.log('🔄 FETCHDEMOGRAPHICSDATA: Data loaded from public folder', {
        featureCount: data?.features?.length,
        selectedState: geoLevel || 'nationwide'
      });
      return data;
    } else {
      // Production: Use dynamic Next.js backend endpoints
      let apiUrl;

      if (geoLevel == 'county') {
        // Fetch county data for specific state
        console.log('🔄 FETCHDEMOGRAPHICSDATA: Fetching county data for state:', areaId);
        apiUrl = `https://delta-ops.vercel.app/api/demographics/county/${areaId}`;
      } else if (geoLevel == 'blockgroup') {
        // Fetch block group data for specific county
        console.log('🔄 FETCHDEMOGRAPHICSDATA: Fetching block group data for county:', areaId);
        // Force TEXAS CloudFront URL for now (Since we only scraped Texas)
        // Ideally this should be dynamic based on stateFips
        apiUrl = `https://ddt94p7yna12s.cloudfront.net/demographics/michigan.geojson`;
      } else {
        // Fetch nationwide data
        console.log('🔄 FETCHDEMOGRAPHICSDATA: Fetching nationwide data');
        apiUrl = `https://delta-ops.vercel.app/api/demographics/nationwide`;
      }

      console.log('🔗 API URL:', apiUrl);
      const response = await fetch(apiUrl);

      if (!response.ok) {
        throw new Error(`Failed to load demographics data: ${response.status}`);
      }

      const data = await response.json();
      console.log('🔄 FETCHDEMOGRAPHICSDATA: Data loaded from API', {
        featureCount: data?.features?.length,
        selectedState: geoLevel || 'nationwide'
      });
      return data;
    }
  } catch (err) {
    console.error('🔄 FETCHDEMOGRAPHICSDATA: Error loading demographics data:', err);
    throw err; // Re-throw to let the component handle it
  }
};

export default fetchDemographicsData; 